
import {throwError as observableThrowError,  Observable ,  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LogService } from 'app/_services/logmanager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';
import { AppConfig } from '../app.config';
import { AlertService } from './alert.service';
import { map, catchError } from 'rxjs/operators';

// https://angular.io/docs/ts/latest/cookbook/component-communication.html
// https://stackoverflow.com/questions/39552388/angular-2-universal-store-global-variables

// https://stackoverflow.com/questions/34731869/wait-for-angular-2-to-load-resolve-model-before-rendering-view-template
// https://angular.io/api/router/Resolve

// ejemplos https://embed.plnkr.co/zL0UlvqNqioAaxwZpZDR/
// https://sebastian-mueller.net/post/angular-2-router-resolve/

// https://blog.thoughtram.io/angular/2016/10/10/resolving-route-data-in-angular-2.html
// TODO: comprobar si hay sessionStorage y usarlo para las comunicaciones en vez de llamar al WS

@Injectable()
export class GlobalsService {

    // Observable string sources
    public datastorage = new Subject<any>();
    public searchUser = new Subject<string>();
    public synced = false;
    private readonly ruta: string = '';
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private router: Router,
        private alertService: AlertService
    ) {
        LogService.log('GlobalsService', 'Construct');
        this.ruta = this.config.apiUrl + this.config.wsapi;
    }

    // setdata
    setData(item: any) {
        LogService.log('GlobalsService', '#### setData *');
        LogService.log('GlobalsService', item);

        if (!this.synced) {
            LogService.log('GlobalsService', '####  [[[ NOT SYNCED ]]] setData *');
        }

        this.datastorage.next(item);
    }

    // Service message commands

    setItems(items: any[]): Promise<void> {

        return new Promise<void> ( resolve => {
            const processes: any[] = [];
            for (let i = 0; i < items.length; i++) {
                processes[i] = this.setItem(items[i].name, items[i].value);
            }

            Promise.all(processes).then(() => {
                resolve();
            });
        });
    }

    setItem(itemname: string, newvalue: any, syncSession?: boolean): Promise<void> {

        return new Promise<void> ( resolve => {
            if (typeof(syncSession) === 'undefined') {
                syncSession = true;
            }
            LogService.log('GlobalsService', '#### setItem ' + itemname + ' = *' + JSON.stringify(newvalue) + '*');

            if (!this.synced) {
                LogService.log('GlobalsService', '####  [[[ NOT SYNCED ]]] setItem ' + itemname + ' = *' + JSON.stringify(newvalue) + '*');
            }

            const newdata = this.datastorage;
            newdata[itemname] = newvalue;
            this.datastorage.next(newdata);

            if (itemname === 'searchUser') {
                this.searchUser.next(newvalue);
            }

            if (syncSession) {
                const params = <any>{
                    'accio': 'WsRefreshInfo',
                    'params': <any> {
                        'id': itemname,
                        'valor': newvalue
                    },
                };
                const body = JSON.stringify(params);
                this.http.post<any>(this.ruta, body, {headers: this.headers}).pipe(map((response) => {
                        LogService.log('GlobalsService', '####  GlobalsService -> Resultado WsRefreshInfo setitem');
                        LogService.log('GlobalsService', response);
                        resolve();
                    }))
                    .pipe(catchError((error: any) => {
                        return observableThrowError(this.wsErrorCatch(error));
                    })).subscribe();
            }
        });

    }
    getItem(itemname: string) {
        LogService.log('GlobalsService', '#### getItem :' + itemname);

        if (!this.synced) {
            LogService.log('GlobalsService', '####  [[[ NOT SYNCED ]]] getItem :' + itemname);
        }

        const valor = this.datastorage[itemname] || '';
        LogService.log('GlobalsService', valor);

        return valor;
    }


    removeItems(items: string[]): Promise<void> {

        return new Promise<void> ( resolve => {
            const processes: any[] = [];
            for (let i = 0; i < items.length; i++) {
                processes[i] = this.removeItem(items[i]);
            }

            Promise.all(processes).then(() => {
                resolve();
            });
        });
    }

    removeItem(itemname: string): Promise<void> {

        return new Promise<void>( resolve => {
            LogService.log('GlobalsService', '####  removeItem :' + itemname);

            if (!this.synced) {
                LogService.log('GlobalsService', '####  [[[ NOT SYNCED ]]] removeItem :' + itemname);
            }

            delete this.datastorage[itemname];

            const params = <any>{
                'accio': 'WsRefreshInfo',
                'params': <any> {
                    'id': 'remove',
                    'valor': itemname
                },
            };
            const body = JSON.stringify(params);
            this.http.post<any>(this.ruta, body, { headers: this.headers })
                .pipe(map((response) => {
                    LogService.log('GlobalsService', 'Resultat WsRefreshInfo removeitem');
                    LogService.log('GlobalsService', response);
                    resolve();
                }))
                .pipe(catchError((error: any) => {
                    return observableThrowError(this.wsErrorCatch(error));
                }))
                .subscribe();
        });


    }

    clear(): Promise<void> {

        return new Promise<void>( resolve => {
            LogService.log('GlobalsService', '####  clear ');

            if (!this.synced) {
                LogService.log('GlobalsService', '####  [[[ NOT SYNCED ]]] clear ');
            }

            this.datastorage.next({});

            const params = <any>{
                'accio': 'WsRefreshInfo',
                'params': <any> {
                    'id': 'clear',
                    'valor': true
                },
            };
            const body = JSON.stringify(params);
            LogService.log('GlobalsService', '####  Resultat WsRefreshInfo clear CALL');
            LogService.log('GlobalsService', this.ruta);
            LogService.log('GlobalsService', body);

            this.http.post<any>(this.ruta, body, { headers: this.headers })
                .pipe(map((response) => {
                    LogService.log('GlobalsService', '####  Resultat WsRefreshInfo clear');
                    LogService.log('GlobalsService', response);
                    resolve();
                }))
                .pipe(catchError((error: any) => {
                    return observableThrowError(this.wsErrorCatch(error));
                }))
                .subscribe();
        });
    }

    setSynced() {
        LogService.log('GlobalsService', '#### synced ');
        this.synced = true;
    }

    wsErrorCatch(error: any) {
        LogService.log('GlobalsService', '****** catch ');
        this.alertService.clearLoading();
        let message = '';
        if (typeof(error.json) !== 'undefined' && error.json().error) {
            message = error.json().error;
        } else {
            // el webservice no ha devuelto un json
            message = 'JSON.';
        }
        this.alertService.error('Data Error:' + message);
        LogService.log('GlobalsService', '****** error ' + message);

        return observableThrowError(message);
    }
}


@Injectable()
export class GlobalsServiceResolver implements Resolve<any> {

    // Observable string sources
    private ruta = '';
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    static wsErrorCatch(error: any) {
        LogService.log('GlobalsServiceResolver', '****** Catch ');
        let message = '';
        if (typeof(error.json) !== 'undefined' && error.json().error) {
            message = error.json().error;
        } else {
            // el webservice no ha devuelto un json
            message = 'JSON.';
        }

        LogService.log('GlobalsServiceResolver', '****** error ' + message);
        return observableThrowError(message);
    }

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private router: Router,
        private globalStorage: GlobalsService
    ) {
        LogService.log('GlobalsServiceResolver', 'Construct');
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        this.ruta = this.config.apiUrl + this.config.wsapi;
        const params = <any>{
            'accio': 'WsRefreshInfo',
            'params': <any> {
                'id': 'refresh',
                'valor': true
            },
        };
        const body = JSON.stringify(params);

        return this.http.post<any>(this.ruta, body, { headers: this.headers })
            .pipe(map((resultado) => {
            LogService.log('GlobalsServiceResolver', '#### returned');
            LogService.log('GlobalsServiceResolver', resultado);

            if (resultado) {
                // Update login info
                this.globalStorage.setItem('currentUser', JSON.stringify(resultado.login), false);
                LogService.log('GlobalsServiceResolver', '#### currentUser');
                LogService.log('GlobalsServiceResolver', this.globalStorage.getItem('currentUser'));

                if (resultado.status !== '100') {
                    // If not OK
                    if (resultado.status === '401') {
                        this.router.navigate(['/login']);
                    }
                    LogService.log('GlobalsServiceResolver', '#### status KO, error ' + resultado.error);

                } else {
                    // If OK
                    const data = resultado.data;
                    this.globalStorage.setData(data);
                    LogService.log('GlobalsServiceResolver', '#### DATA: ' + JSON.stringify(data));

                    if (data[0]) {
                        for (const x in data[0].info) {
                            if (data[0].info.hasOwnProperty(x)) {
                                if (x !== 'currentUser') {
                                    this.globalStorage.setItem(x, data[0].info[x], false);
                                }
                            }
                        }
                    }
                }
            } else {
                LogService.log('GlobalsServiceResolver', '####  error 2');
            }

            LogService.log('GlobalsServiceResolver', '####  DATA RESTORED');
            this.globalStorage.setSynced();
        }))
        .pipe(catchError((error: any) => {
            return observableThrowError(GlobalsServiceResolver.wsErrorCatch(error));
        }));
    }
}
